/**
 * A composable for formatting prices in a consistent way across the application.
 * @returns An object containing the formatPrice function
 */
export const useFormatPrice = () => {
  /**
   * Formats a price number according to the application's standards.
   * @param price - The price to format
   * @returns The formatted price string
   */
  const formatPrice = (price: number): string => {
    const num = Number(price);

    if (num % 1 === 0) {
      return new Intl.NumberFormat('en-GB', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(num);
    } else {
      return new Intl.NumberFormat('en-GB', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(num);
    }
  };

  return {
    formatPrice,
  };
};
